module.exports = __webpack_public_path__ + "static/img/img_p1_1_phone.d543d52.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_p1_1_phone.png
// module id = OLS+
// module chunks = 1